module.exports = __webpack_public_path__ + "static/media/archive.d055fa7c.svg";